import MonthViewCalendar from './monthly/MonthViewCalendar';
import PropTypes from 'prop-types';

const MonthlyView = ({ noClSheets }) => {
  return (
    <MonthViewCalendar noClSheets={noClSheets} />
  )
}

MonthlyView.propTypes = {
  noClSheets: PropTypes.arrayOf(PropTypes.string),
}

export default MonthlyView;